export default __webpack_public_path__ + "static/media/project4.07dd5fea.JPG";